import { ProgramRequestStatus } from "../../../models/ProgramRequest/ProgramRequestStatus";
import { RoleEnum } from "../../../models/User/RoleEnum";

const isInstitutionUser = (roleId: RoleEnum | undefined): boolean =>
  roleId === RoleEnum.InstitutionAdmin ||
  roleId === RoleEnum.InstitutionDirector;

export const canEditMinisterMzomAdditionalDocumentation = (
  statusId: ProgramRequestStatus | undefined,
  roleId: RoleEnum | undefined,
): boolean => {
  if (!isInstitutionUser(roleId)) {
    return false;
  }

  return statusId === ProgramRequestStatus.Opened ||
    statusId === ProgramRequestStatus.SentMZO ||
    statusId === ProgramRequestStatus.UnlockedMZO;
};
